import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import SupervisiJenazahSvc from "@/services/SupervisiJenazahService";

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "supervisi-jenazah"
})
class SupervisiJenazahModule extends VuexModule {
  items: any[] = [];
  currentItem: any = null;
  loading = false;
  meta: any = {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 0
  };

  @Mutation SET_ITEMS(val: any[]) {
    this.items = val;
  }

  @Mutation SET_CURRENT_ITEM(val: any) {
    this.currentItem = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation SET_META(val: any) {
    this.meta = val;
  }

  @Action async fetchList(params: any = {}) {
    this.SET_LOADING(true);
    try {
      const dt = await SupervisiJenazahSvc.getAll(params);
      const { data, meta } = dt.data;
      this.SET_ITEMS(data || []);
      this.SET_META(meta || {});
    } catch {
      this.SET_ITEMS([]);
    }
    this.SET_LOADING(false);
  }

  @Action async fetchOne(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await SupervisiJenazahSvc.find(id);
      const { data } = dt.data;
      this.SET_CURRENT_ITEM(data || null);
    } catch {
      this.SET_CURRENT_ITEM(null);
    }
    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_ITEMS([]);
    this.SET_CURRENT_ITEM(null);
    this.SET_META({ current_page: 1, last_page: 1, per_page: 10, total: 0 });
  }
}

export const storeSupervisiJenazah = getModule(SupervisiJenazahModule);
